import { Component, ElementRef, Inject, LOCALE_ID, OnDestroy, OnInit, QueryList, Sanitizer, ViewChild, ViewChildren } from '@angular/core';
import { UseraccessserviceService } from 'src/app/services/useraccessservice.service';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { AdminAction } from 'src/app/models/adminaction.model';
import { UtilService } from 'src/app/services/util.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { PaymentService } from 'src/app/services/payment.service';
import { SchoolPackageViewTile } from 'src/app/models/schoolpackageviewtile.model';
import { SchoolPackageService } from 'src/app/services/school-package.service';
import { Moduleviewtile } from 'src/app/models/school/moduleviewtile.model';
import { NgSelectComponent } from '@ng-select/ng-select';
import { formatNumber } from '@angular/common';
import { DetectlocationService } from 'src/app/services/detectlocation.service';
import { PaymentiframeComponent } from 'src/app/reuseableui/paymentiframe/paymentiframe.component';

declare const $: any;

@Component({
  selector: 'app-module-package-details',
  templateUrl: './module-package-details.component.html',
  styleUrls: ['./module-package-details.component.css']
})
export class ModulePackageDetailsComponent implements OnInit, OnDestroy {

    constructor(private packageservice: SchoolPackageService, private utilservice: UtilService, public headerinfo: ComponentheaderService, private router: Router, private moduleService: ModulemanagementService, private locationService: DetectlocationService,
    private activatedroute: ActivatedRoute, private toastr: ToastrService, private payments: PaymentService, @Inject(LOCALE_ID) public locale: string) { 
    headerinfo.setHeaderDisplay('Loading Package...', [], []);
    this.windowMessageReceivedHandler = this.windowMessageReceived.bind(this);
  }
  ngOnDestroy(): void {
    window.removeEventListener('message', this.windowMessageReceivedHandler);
  }

  package: SchoolPackageViewTile = new SchoolPackageViewTile();
  modules: Moduleviewtile[] = [];
  currentUserIsAdmin: boolean = false;
  moduleIdBeingDeleted: number;
  currency: string;
  currentUserIsStudent: boolean = false;
  notauser: boolean = false;
  modulesnotinpackage: Moduleviewtile[] = [];
  newModuleId: number;
  windowMessageReceivedHandler;
  @ViewChildren('hidewhenloading') hidewhenloading: QueryList<ElementRef>;
  @ViewChild('newModuleIdField') newModuleIdField: NgSelectComponent;
  @ViewChild('payment') paymentComponent!: PaymentiframeComponent;
  loadingPayment = false

  async windowMessageReceived(event: any){
    //debugger;
    if(event.data.type == 'paymentdone'){
      if(event.data.responsecode == '0'){
        this.toastr.success('Payment Successful');
        await this.loadPackageInfo(this.package.id);
        this.loadSchoolPackageModules(this.package.id);
      }
      else{
         if(isNaN(event.data.responsecode)){
           this.toastr.error(event.data.reason, 'Payment Error', { timeOut: 0, closeButton: true});
         }
         else{
          this.toastr.warning(event.data.reason, 'Payment Processing...', { timeOut: 0, closeButton: true});
         }
      }
      this.paymentComponent.closePaymentWindow();
    }
  }

  async ngOnInit() {
    this.currency = await this.locationService.getCurrencyString();
    const packageId = this.activatedroute.snapshot.queryParams.packageId;
    this.headerinfo.pageLoadingStarted(this);

    const promises: Promise<any>[] = [];
    let promise;
    //debugger;
    promise = this.loadPackageInfo(packageId);
    promises.push(promise);

    promise = this.loadSchoolPackageModules(packageId);

    promises.push(promise);

    promise = this.utilservice.checkUserIsSubdomainAdmin().toPromise().then((data: boolean) => {
      //debugger;
      this.currentUserIsAdmin = data;
    });
    promises.push(promise);

    promise = this.packageservice.userIsSchoolPackageStudent(packageId).toPromise().then((data) => {
      this.currentUserIsStudent = data;
    });
    promises.push(promise);

    await Promise.all(promises);

    let adminActions = [];

    if(this.currentUserIsAdmin){
      adminActions = [
        {
          displaytext: 'Edit Package',
          route: '/user/editpackage',
          params: { packageId: packageId },
          classes: ['fas', 'fa-edit'],
        },
        {
           displaytext: 'Delete Package',
           callback: this.popconfirmdelete.bind(this),
           classes: ['fas', 'fa-trash']
        },
        {
          displaytext: 'Add Courses',
          callback: this.showAddCourseModal.bind(this),
          classes: ['fas', 'fa-plus']
        }
      ];
    }

    this.headerinfo.setHeaderDisplay(this.package.name, [
      { displaytext: "School", route: `schoolhome` },
      { displaytext: "Package", route: this.activatedroute.snapshot.url.join('/'), params: this.activatedroute.snapshot.queryParams }
    ], adminActions);

    window.addEventListener('message', this.windowMessageReceivedHandler);

    this.headerinfo.pageLoadingDone(this);
  }

  private loadPackageInfo(packageId: any) {
    const promise = this.packageservice.getSchoolPackage(packageId).toPromise().then((data) => {

      this.package = data;
      //debugger;
    });
    return promise;
  }

  openPaymentWindow(url: any) {
    if (url)
      this.paymentComponent.openPaymentWindow(url);
    else
      this.loadingPayment = false;
  }

  async enroll(){
    if(this.package.amountPerStudent > 0){
      let regionId = await this.locationService.getRegionID();
      let paymentinfo: any;

      if (regionId === 1) {
        paymentinfo = await this.payments.initiatePackagePayment(this.package.id).toPromise();
      }
      else {
        paymentinfo = await this.payments.initiateStripePackagePayment(this.package.id).toPromise()
      }
      const paymenturl = paymentinfo.url;
      this.openPaymentWindow(paymenturl);
    }
    else{
      await this.packageservice.enrollforpackage(this.package.id).toPromise();
      this.toastr.success("Successfully Enrolled");
      await this.loadSchoolPackageModules(this.package.id);
    }
  }

  loadSchoolPackageModules(packageId): Promise<void>{
    const promise = this.packageservice.getSchoolPackageModules(packageId, true).toPromise().then((data) => {
      this.modules = data;
      //debugger;
    });
    return promise;
  }

  async deletePackage(){
    $('#deletePackage').modal('hide');

    await this.packageservice.deletePackage(this.package.id).toPromise();
    // (data: any) => {
    //this.addAdminError = null;
    // this.headerinfo.pageLoadingDone(this);

    this.toastr.success("Package Deleted");
    this.router.navigate(['user/schoolhome']);
  }

  popconfirmdelete(){
    $('#deletePackage').modal('show');
  }

  async showAddCourseModal(){
    if(!this.modulesnotinpackage || this.modulesnotinpackage.length == 0){
      this.modulesnotinpackage = await this.packageservice.getSchoolPackageModules(this.package.id, false).toPromise();
    }
    $('#selectCourseDialog').modal('show');
  }

  closeSelectCourseDialog(){
    this.newModuleIdField.clearModel();
    $('#selectCourseDialog').modal('hide');
    return false;
  }

  async addCourse(){
    //debugger;
    await this.packageservice.addPackageModule(this.package.id, this.newModuleId).toPromise();
    await this.loadSchoolPackageModules(this.package.id);
    this.closeSelectCourseDialog();
  }

  deletePackageModuleClicked(module){
    this.moduleIdBeingDeleted = module.id;
    $('#deletePackageModule').modal('show');

  }

  async deletePackageModule(){
    await this.packageservice.removePackageModule(this.package.id, this.moduleIdBeingDeleted).toPromise();
    await this.loadSchoolPackageModules(this.package.id);
    this.modulesnotinpackage = [];//to force the list to reload so that deleted courses can be included
    $('#deletePackageModule').modal('hide');
    this.toastr.success('Course Removed');
  }

  formatNumber(_number: number){
    return formatNumber(_number, this.locale);
  }

}
